<template>
    <button
        v-b-tooltip.hover.topleft="$t('Need help? Go to Knowledge Base')"
        type="button"
        data-cy="notification-btn"
        class="btn btn-link text-decoration-none d-flex align-items-center mx-1"
        onclick="window.open('https://www.fooddocs.com/knowledge', '_blank')"
    >
        <i class="fd-question font-size-lg mr-2"></i>
        <span class="font-size-xs">{{ $t('help') }}</span>
    </button>
</template>

<script>
export default {
    compatConfig: {
        INSTANCE_EVENT_EMITTER: true, // bv-tooltip
    },
};
</script>
